// extracted by mini-css-extract-plugin
export default {"input":"Input_input__+xIWo","label":"Input_label__Li2pp","border":"Input_border__UAqXY"};